module.exports = __webpack_public_path__ + "static/media/ic_msg_disabled.8886ad32.svg";